import { rankings } from "@/mocks/movies";

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            本周观影排行榜
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">
            根据近七日站内浏览与收藏热度整理的前 10 名，覆盖电影与剧集，
            数据每日滚动更新，是选片时最省心的参考。
          </p>
        </div>
        <span className="inline-flex w-fit items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold">
          <i className="ri-refresh-line" aria-hidden="true" />
          每日滚动更新
        </span>
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        {rankings.map((r) => (
          <article
            key={r.rank}
            className="flex items-center gap-4 rounded-xl bg-background-50 border border-background-200 p-3.5"
          >
            <span
              className={`w-8 shrink-0 text-center font-heading text-xl font-bold ${
                r.rank <= 3 ? "text-accent-600" : "text-foreground-400"
              }`}
            >
              {r.rank}
            </span>
            <div className="w-14 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
              <img
                src={r.poster}
                alt={`${r.title} 海报`}
                title={`${r.title} 在线观看 - 八戒影院`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1">
                {r.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{r.genre}</p>
            </div>
            <div className="shrink-0 text-right">
              <p className="text-sm font-bold text-foreground-800 flex items-center gap-1 justify-end">
                <i className="ri-star-fill text-primary-500 text-xs" aria-hidden="true" />
                {r.rating}
              </p>
              <p className="mt-1 text-xs text-foreground-400 flex items-center gap-1 justify-end">
                <i className="ri-fire-line text-accent-500" aria-hidden="true" />
                {r.heat}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}